"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupSettingsListener = exports.setSettingsAction = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const GameSession_1 = require("~/game/GameSession");
exports.setSettingsAction = (0, toolkit_1.createAction)("setSettingsAction");
const setupSettingsListener = (startListening) => {
    startListening({
        actionCreator: exports.setSettingsAction,
        effect: ({ payload }, api) => {
            api.extra.sessionHolder.set(new GameSession_1.GameSession(payload));
        },
    });
};
exports.setupSettingsListener = setupSettingsListener;
